import { withDependencies } from '@wix/thunderbolt-ioc'
import { ControllersInvoker, ControllersInvokerSymbol, DSViewModeAPISymbol, PlatformSymbol, IViewMode, NavigationInfoSymbol, PlatformDsApi, isViewerFragmentSymbol } from '@wix/thunderbolt-symbols'
import { NavigationManagerSymbol, INavigationManager } from 'feature-navigation-manager'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import type { INavigationInfo } from 'ds-feature-editor-navigation'
import type { PlatformModelUpdateHandlers } from '../types'
import { name } from '../symbols'

export const platformSideEffectsHandlers = withDependencies(
	[PlatformSymbol, ControllersInvokerSymbol, NavigationManagerSymbol, NavigationInfoSymbol, DSViewModeAPISymbol, isViewerFragmentSymbol],
	(
		platformApi: PlatformDsApi,
		controllersInvoker: ControllersInvoker,
		navigationManager: INavigationManager,
		navigationInfo: INavigationInfo,
		viewMode: IViewMode,
		isViewerFragment: boolean
	): IModelUpdatesHandlersImplementor<PlatformModelUpdateHandlers> => {
		const shouldInvokeSideEffect = () =>
			!(
				isViewerFragment ||
				navigationInfo.isDuringInitialNavigationPhase() ||
				navigationInfo.isDuringFinalNavigationPhase() ||
				navigationManager.isDuringNavigation() ||
				navigationManager.isFirstNavigation() ||
				viewMode.isDuringViewModeSwitch()
			)

		return {
			featureName: name,
			handlers: {
				async rerunPlatform() {
					if (shouldInvokeSideEffect()) {
						await platformApi.runPlatform()
					}
				},
				async onOoiControllerAdded() {
					if (shouldInvokeSideEffect()) {
						await platformApi.runPlatform()
					}
				},
				onOoiControllerRemoved({ controllerId }) {
					if (shouldInvokeSideEffect()) {
						controllersInvoker.revokeUpdates(controllerId)
					}
				},
				onLivePreviewControllerConfigUpdate({ config, controllerId }) {
					if (shouldInvokeSideEffect()) {
						controllersInvoker.invokeConfigUpdate(controllerId, config)
					}
				},
			},
		}
	}
)
